
import React from 'react';
import { Game } from "@/types/game";
import { GamesTable } from "./GamesTable";

interface GamesListProps {
  games: Game[];
  onEdit: (game: Game) => void;
  onDelete: (id: string) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const GamesList: React.FC<GamesListProps> = ({ 
  games, 
  onEdit, 
  onDelete, 
  searchTerm, 
  setSearchTerm 
}) => {
  return (
    <div className="bg-[#181D24] rounded-lg border border-[#222A35] overflow-hidden shadow-xl">
      <GamesTable 
        games={games} 
        onEdit={onEdit} 
        onDelete={onDelete}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </div>
  );
};
